export default __webpack_public_path__ + "static/media/live.08dc1b3d.svg";